<template>
	<div class="product-info" v-bind:style="getProductStyle" @click.stop="productClick">
    <img class="product-icon" v-bind:style="getProductLabelStyle"   src='../../../assets/image/activity/goodProject@2x.png'>
    <img class="product-icon" v-bind:style="getProductIconStyle"  v-bind:src="item.default_photo.large" v-if='item.default_photo'>
    <img class="product-icon" v-bind:style="getProductIconStyle" src="../../../assets/image/change-icon/default_image_02@2x.png" v-else>
    <span class="product-title">{{toNewName(item.name)}}</span>
    <div class="product-bottom">
      <span class="product-price">￥{{item.current_price || item.price}}</span>
      <img src="../../../assets/image/change-icon/add@2x.png" @click.stop="_cartAdd(item.id)">
    </div>
		<shopping v-if='isShowcartInfo && showCartInfo(item, cartAddType)' :isShowcartInfo="isShowcartInfo" ></shopping>
		<!-- 加入购物车显示动画 -->
		<div class="ui-cart-animation" v-if='isAnimation'>
			<mt-spinner type="snake" color='#FA800A'></mt-spinner>
		</div>
  </div>
</template>

<script>
import { Toast, Spinner } from 'mint-ui';
import { mapState, mapMutations } from 'vuex';
import { cartAdd, cartQuantity } from '../../../api/cart';
import shopping from '../../product-detail/child/Shopping';
import { productGet } from '../../../api/product';

export default {
  name: 'TopicProductBody',
  data() {
    return {
      itemWidth : 0,
      itemHeight : 0,
      showRightBorder: this.index % 2 == 0,
      isAnimation: false, //加入购物车成功之后是否显示动画
      toastConfig: {
        message: '商品达到每单限购数量',
        position: 'middle'
      },
    };
  },
  components: {
    shopping
  },
  props: ['item', 'index', 'cartAddType'],
  computed: {
		...mapState({
      isOnline: state => state.auth.isOnline,
      //开关，是否显示购物车浮层
      isShowcartInfo: state => state.detail.isShowcartInfo,
		}),
    getProductStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width / 3 - 20 - 1;
      let itemHeight = itemWidth * (132.0 / 94.0);
      this.itemWidth = itemWidth;
      this.itemHeight = itemHeight;
      return {
        width: itemWidth + 'px',
        //height: itemHeight + 'px'
      }
    },
    getProductLabelStyle:function(){
      const { width, height } = window.screen
      let itemWidth = (this.itemWidth - 20)/4;
      let itemHeight = itemWidth;
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px',
        'margin-bottom': - itemHeight + 'px',
        'margin-left': - (this.itemWidth/2+itemWidth-10) + 'px',
        'align-self': 'left',
        'z-index': 300
      }
    },
    getProductIconStyle: function () {
      const { width, height } = window.screen
      let itemWidth = this.itemWidth - 20;
      let itemHeight = itemWidth;
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
  },
  created() {
    this.$on('start-addcart-animation', () => {
      this.isAnimation = true;
    });
    this.$on('end-addcart-animation', () => {
      this.isAnimation = false;
      this.saveCartState(false);
console.log("Topic / HomeProducBody.vue / end-addcart-animation")
			Toast({message: '加入成功', position: 'middle', duration: 3000});
    });
  },
  methods: {
		...mapMutations({
			saveCartState: 'saveCartState',
			changeType: 'changeType',
				saveInfo: 'saveDetailInfo',
				setCurrentProductId: 'setCurrentProductId',
				saveExchangeScoreState: 'saveExchangeScoreState',
				saveNumber: 'saveNumber',
        setCartNumber: 'setCartNumber'
		}),
		showCartInfo: (item, cartAddType)=>{
console.log("Topic / TopicProductBody.vue / showCartInfo / cartAddType : ", cartAddType, " item : ", item);
			if (cartAddType == 1) {
				// 不显示购物车浮层，直接加入购物车
				return false;
			} else if (cartAddType == 2) {
				// 单规格商品不显示浮层，直接加入购物车，多规格商品显示浮层提示选择规格
				if (item.properties && item.properties.length>0 && item.properties[0].attrs.length > 1) {
					return true;
				} else {
					return false;
				}
			} else {
				// 显示购物车浮层
				return true;
			}
		},
		/*
			getDetail: 获取商品详情， 并且存入状态管理
		*/
		getDetail(productId) {
			this.setCurrentProductId(productId);
			productGet(productId).then(res => {
				if (res) {
					this.productDetail = res.product;
					this.saveInfo(res.product);
					this.saveNumber(1);
					this.saveExchangeScoreState(this.productDetail.exchange_score);
console.log("TopicProductBody.vue / getDetail / res.product : ", res.product);
					this.saveCartState(true);
					this.changeType('加入购物车');
				}
			})
		},
    /*
		 *  getCartNumber: 获取购物车数量
		 */
    getCartNumber() {
      cartQuantity().then(res => {
        if (res) {
          this.setCartNumber(res.quantity);
        }
      });
    },
		/*
		 * cartAdd: 加入购物车
		 * @param： product： 商品id
		*/
		_cartAdd(product) {
			if (this.isOnline) {
				if ( this.showCartInfo(this.item, this.cartAddType) ) {
					this.getDetail(product);
				} else {
					// 直接加入购物车
					cartAdd(product, '', 1,this.$store.getters.getUser.id).then(res => {
						if (res) {
              this.getCartNumber();
							// this.$parent.$emit('get-cart-quantity');
							Toast({message: '加入成功', position: 'middle', duration: 5000});
						}
					}, (error) => {
						Toast('请求异常:'+error.errorMsg);
					});
				}

			} else {
				this.$router.push({'name': 'signin'});
			}
		},
    productClick: function() {
      this.$router.push({'name': 'product', 'query': {'id': this.item.id}});
    },
    toNewName(name){
      const { width, height } = window.screen
      /*let itemWidth = this.itemWidth - 20;
      let wordNumber = Math.floor(itemWidth/14)
      if(name && name.length > wordNumber){
        return name.substring(0,wordNumber)+'...'
      }else{
        return name
      }*/
      let itemWidth = this.itemWidth - 4;
      let numofLine = Math.floor(itemWidth/14); // font-size:14px
      let attr = ''; 
      let delim = ' ';

      if (this.item.properties.length>0 && this.item.properties[0].attrs.length>0) {
        attr = (this.item.properties[0].attrs[0].attr_value+'/'+this.item.properties[0].name).trim();
      }/**/

      if (attr && (this.item.is_weight==2)) {
        attr = '约'+attr;
      }

      let wordNumber = numofLine*2*2-this.utils.strLen(attr)-this.utils.strLen(delim);  //1.2：显示一行多(1.2行)，后半行显示规格
      if(name && this.utils.strLen(name) <= numofLine*2){
        return name+(attr?"\n"+attr:'')
      }else if(name && (this.utils.strLen(name) >= wordNumber)){
        return name.substring(0,(wordNumber/2)-1)+'...'+(attr?delim+attr:'');
      }else{
        return name+(attr?delim+attr:'');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.border {
  border-right: 1px solid #F5F5F5;
}
.product-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px;
  justify-content: flex-end;
  border-bottom: 1px solid #F5F5F5;
  .product-icon {
    align-self: center;
  }
  .product-title {
    color: #333333;
    font-size: 14px;
    height:38px;
    margin-top: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: pre-wrap;  // 允许强制换行
  }
  .product-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    .product-price {
      color: #eb8419; // #666666;
      font-size: 12px;
      font-weight: 800;
    }
    .product-buy {
      color: #999999;
      font-size: 12px;
    }
		img {
			width: 22px;
			height: 20px;
		}
  }
}

</style>



// WEBPACK FOOTER //
// src/page/topic/child/TopicProductBody.vue